import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * Automatically scrolls to the top of the page whenever the route changes.
 * This fixes the issue where internal links land in the middle of pages
 * instead of at the top.
 * 
 * Usage: Place inside BrowserRouter in App.tsx
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    window.scrollTo(0, 0);
  }, [pathname]);

  // This component renders nothing
  return null;
};

export default ScrollToTop;
